/* eslint-disable */

import {
  Area,
  Bar,
  Brush,
  ComposedChart,
  Label,
  Layer,
  Legend,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Text,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import React from "react";
import TimelineHelper from "./timeline_helper";
import { MEASUREMENTS_META } from "./graph_settings";
import cropr from "../shared/utils/cropr";
import gettext from "../shared/utils/gettext";

export class DacomBrush extends Brush {
  renderTraveller(travellerX, id) {
    const { y, travellerWidth, height, stroke } = this.props;
    const lineY = Math.floor(y + height / 2) - 1;
    const x = Math.max(travellerX, this.props.x);
    var threeLines = "";
    for (var i = 0; i < 3; i++) {
      threeLines += <rect x={x + 7 + i * 2} y={y + 4} width={2} height={travellerWidth - 8} />;
    }

    return (
      <Layer
        className="recharts-brush-traveller"
        onMouseEnter={this.handleEnterSlideOrTraveller}
        onMouseLeave={this.handleLeaveSlideOrTraveller}
        onMouseDown={this.travellerDragStartHandlers[id]}
        onTouchStart={this.travellerDragStartHandlers[id]}
        style={{ cursor: "col-resize" }}
      >
        <rect x={x} width={2} height={height} y={y} fill={stroke}></rect>
        <rect
          transform={`translate(${id === "startX" ? "-" + travellerWidth : "2"},${
            height / 2 - travellerWidth / 2
          })`}
          x={x}
          y={y}
          width={travellerWidth}
          height={travellerWidth}
          fill={stroke}
          stroke="none"
        />
        <g
          transform={`translate(${id === "startX" ? "-" + travellerWidth : "2"},${
            height / 2 - travellerWidth / 2
          })`}
        >
          {[0, 1, 2].map((i) => {
            return (
              <rect
                x={x + 5 + i * 4}
                y={y + 4}
                width={2}
                height={travellerWidth - 8}
                key={`stroke_${id}_${i}`}
              />
            );
          })}
        </g>
      </Layer>
    );
  }

  renderText() {
    const { startIndex, endIndex, y, height, travellerWidth, stroke } = this.props;
    const { startX, endX } = this.state;
    const offset = 5;
    const attrs = {
      pointerEvents: "none",
      fill: "#000",
    };

    return (
      <Layer className="recharts-brush-texts">
        <Text
          textAnchor="end"
          verticalAnchor="middle"
          x={Math.min(startX, endX) - offset - 20}
          y={y + height / 2}
          {...attrs}
        >
          {this.getTextOfTick(startIndex)}
        </Text>
        <Text
          textAnchor="start"
          verticalAnchor="middle"
          x={Math.max(startX, endX) + travellerWidth + offset}
          y={y + height / 2}
          {...attrs}
        >
          {this.getTextOfTick(endIndex)}
        </Text>
      </Layer>
    );
  }
}

class CropFieldTimeline extends React.Component {
  composedChart(options) {
    const brush = options.brush || false;
    const state = this.props.timeline_state;
    const ticks = state.ticks;
    const showBenchmarkData = state.benchmarkData && state.benchmarkData.length > 0;
    const weatherDataAccum = state.weatherData
      .map((m) => ({
        ...m,
        ...(state.precipitationData.length
          ? {
              precipitation_sum: null,
            }
          : {}),
      }))
      .concat(state.weatherForecast)
      .concat(state.precipitationData);
    const showPrecipitationDeficit = Boolean(
      weatherDataAccum.find(
        ({ precipitation_deficit_accum, precipitation_deficit_accum_forecast }) =>
          precipitation_deficit_accum !== null || precipitation_deficit_accum_forecast !== null
      )
    );
    const showPrecipitation = Boolean(
      weatherDataAccum.find(
        ({ precipitation_sum, precipitation_forecast }) =>
          precipitation_sum !== null || precipitation_forecast !== null
      )
    );
    const showTemperature = Boolean(
      weatherDataAccum.find(
        ({ air_temperature_forecast, air_temperature_mean }) =>
          air_temperature_forecast !== null || air_temperature_mean !== null
      )
    );
    const records = cropr.records.filter(
      (record) =>
        record.get("processing_state") === "performed" &&
        record.get("cropfield") === this.props.cropfield.id
    );
    const plantRecordDate = TimelineHelper.getPlantDate(records);
    const harvestRecordDate = TimelineHelper.getHarvestDate(records);
    let graph_data = this.props.parent.getGraphData();
    return (
      <ComposedChart
        allowDataOverflow
        data={graph_data}
        syncId={brush ? "cropfield_detail_graphs" : ""}
      >
        {showTemperature && (
          <YAxis
            label={MEASUREMENTS_META.air_temperature.unit}
            domain={MEASUREMENTS_META.air_temperature.domain}
            stroke={MEASUREMENTS_META.air_temperature.stroke}
            allowDataOverflow={MEASUREMENTS_META.air_temperature.clip}
            type="number"
            yAxisId={1}
            hide
          />
        )}
        {showPrecipitation && (
          <YAxis
            label={MEASUREMENTS_META.precipitation.unit}
            domain={MEASUREMENTS_META.precipitation.domain}
            stroke={MEASUREMENTS_META.precipitation.stroke}
            type="number"
            yAxisId={2}
            hide
          />
        )}
        {showPrecipitationDeficit && (
          <YAxis
            label={MEASUREMENTS_META.precipitation_deficit.unit}
            domain={MEASUREMENTS_META.precipitation_deficit.domain}
            stroke={MEASUREMENTS_META.precipitation_deficit.stroke}
            allowDataOverflow={MEASUREMENTS_META.air_temperature.clip}
            type="number"
            yAxisId={3}
            hide
          />
        )}
        <YAxis
          label={MEASUREMENTS_META.ndvi.unit}
          domain={MEASUREMENTS_META.ndvi.domain}
          stroke={MEASUREMENTS_META.ndvi.stroke}
          type="number"
          yAxisId={0}
          hide
        />
        {brush && (
          <XAxis
            dataKey="date"
            domain={state.graphDomain}
            name="Date"
            tickFormatter={(date) => moment.unix(date).format("LL")}
            scale="time"
            ticks={ticks}
            interval={0}
            padding={{ left: 30, right: 30 }}
          />
        )}
        <Tooltip
          cursor={{ strokeDasharray: "3 3" }}
          content={TimelineHelper.renderTooltip(this.records, graph_data)}
        />
        <Legend align="right" verticalAlign="top" iconSize={10} />
        {showBenchmarkData ? (
          <Area
            type="monotone"
            dataKey="bm_std_max"
            stroke={MEASUREMENTS_META.benchmark.stroke}
            fill={MEASUREMENTS_META.benchmark.fill}
            name={gettext("Benchmark NDVI")}
            connectNulls
            legendType="none"
          />
        ) : null}
        {showBenchmarkData ? (
          <Area
            type="monotone"
            dataKey="bm_std_min"
            stroke={MEASUREMENTS_META.benchmark.stroke}
            fill="#FFF"
            fillOpacity={1}
            name={gettext("Benchmark NDVI")}
            connectNulls
            legendType="none"
          />
        ) : null}
        <Line
          isAnimationActive={false}
          type="monotone"
          name="NDVI"
          dataKey="ndvi_avg"
          stroke={MEASUREMENTS_META.ndvi.stroke}
          strokeWidth={3}
          legendType="rect"
          connectNulls
          yAxisId={0}
        />
        {showTemperature && (
          <Area
            isAnimationActive={false}
            dot={false}
            type="monotone"
            name={gettext("Temperature")}
            dataKey="air_temperature_mean"
            stroke="none"
            fill={MEASUREMENTS_META.air_temperature.stroke}
            fillOpacity={0.4}
            // strokeWidth={2}
            legendType="rect"
            connectNulls
            yAxisId={1}
          />
        )}
        {showTemperature && (
          <Area
            isAnimationActive={false}
            dot={false}
            type="monotone"
            name={gettext("Temp. forecast")}
            dataKey="air_temperature_forecast"
            stroke="none"
            fill={MEASUREMENTS_META.air_temperature.stroke}
            fillOpacity={0.4}
            strokeDasharray="3 4 5 2"
            // strokeWidth={1}
            legendType="none"
            connectNulls
            yAxisId={1}
          />
        )}
        {showPrecipitation && (
          <Bar
            isAnimationActive={false}
            dot={false}
            barSize={2}
            name={gettext("Precipitation")}
            dataKey="precipitation_sum"
            stroke={MEASUREMENTS_META.precipitation.stroke}
            fill={MEASUREMENTS_META.precipitation.stroke}
            legendType="rect"
            connectNulls
            yAxisId={2}
          />
        )}
        {showPrecipitation && (
          <Bar
            animationEasing={"ease-out"}
            dot={false}
            barSize={1}
            name={gettext("Precipitation forecast")}
            dataKey="precipitation_forecast"
            stroke={MEASUREMENTS_META.precipitation.stroke}
            fill={MEASUREMENTS_META.precipitation.stroke}
            legendType="none"
            connectNulls
            yAxisId={2}
          />
        )}
        {showPrecipitationDeficit && (
          <Line
            isAnimationActive={false}
            dot={false}
            type="monotone"
            name={gettext("Precipitation deficit")}
            dataKey="precipitation_deficit_accum"
            stroke={MEASUREMENTS_META.precipitation_deficit.stroke}
            strokeWidth={2}
            legendType="rect"
            connectNulls
            yAxisId={3}
          />
        )}
        {showPrecipitationDeficit && (
          <Line
            isAnimationActive={false}
            dot={false}
            type="monotone"
            name={gettext("Precipitation deficit forecast")}
            dataKey="precipitation_deficit_accum_forecast"
            stroke={MEASUREMENTS_META.precipitation_deficit.stroke}
            strokeWidth={1}
            legendType="rect"
            connectNulls
            yAxisId={3}
          />
        )}
        <Line
          isAnimationActive={false}
          name={gettext("Activities")}
          dataKey="records"
          legendType="circle"
          strokeWidth={0}
          stroke="#F9C342"
          dot={{ stroke: "#F9C342", strokeWidth: 5 }}
          yAxisId={0}
        />
        <ReferenceLine x={moment().unix()} stroke="#A9B6BA" strokeDasharray="3 3">
          <Label value={gettext("now")} position="insideTopRight" />
        </ReferenceLine>
        {plantRecordDate && (
          <ReferenceLine
            x={moment(plantRecordDate, "DD-MM-YYYY").unix()}
            stroke="#A9B6BA"
            strokeDasharray="3 3"
          >
            <Label value={gettext("Plant")} position="insideTopRight" />
          </ReferenceLine>
        )}
        {harvestRecordDate && (
          <ReferenceLine
            x={moment(harvestRecordDate, "DD-MM-YYYY").unix()}
            stroke="#A9B6BA"
            strokeDasharray="3 3"
          >
            <Label value={gettext("Harvest")} position="insideTopRight" />
          </ReferenceLine>
        )}
        {brush && (
          <DacomBrush
            key="dacom_brush"
            dataKey="date"
            startIndex={cropr.brush_state.startIndex}
            endIndex={cropr.brush_state.endIndex}
            stroke="#FFCF4E"
            travellerWidth={20}
            onChange={(brushState) => {
              cropr.brush_state = brushState;
            }}
            tickFormatter={(v) => {
              return moment.unix(v).format("LL");
            }}
          >
            {this.composedChart(false)}
          </DacomBrush>
        )}
      </ComposedChart>
    );
  }

  render() {
    let state = this.props.timeline_state,
      loading = Boolean(state.loading.length);
    return (
      <div className="card">
        <div className="card-body">
          <div className="card-content">
            {this.props.benchmark_header && (
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">{gettext("Benchmark filter")}</h5>
                  {state.benchmarkCropfieldCount < 8 && (
                    <h6 className="card-subtitle mb-2 text-red">
                      {gettext("This filter has too few results for a benchmark")}
                    </h6>
                  )}
                  <div className="form-check custom-control-inline custom-control custom-checkbox">
                    <input
                      className="form-check-input custom-control-input"
                      type="checkbox"
                      id="checkbox_variety"
                      data-filter="variety"
                      value="variety"
                      onChange={(e) => {
                        return this.props.changeBenchmarkFilter(e, state.benchmarkFilter);
                      }}
                    />
                    <label
                      className="form-check-label custom-control-label"
                      htmlFor="checkbox_variety"
                    >
                      {gettext("Variety")}
                    </label>
                  </div>
                  <div className="form-check custom-control-inline custom-control custom-checkbox">
                    <input
                      className="form-check-input custom-control-input"
                      type="checkbox"
                      id="checkbox_soiltype"
                      data-filter="soil_type"
                      value="variety"
                      onChange={(e) => {
                        return this.props.changeBenchmarkFilter(e, state.benchmarkFilter);
                      }}
                    />
                    <label
                      className="form-check-label custom-control-label"
                      htmlFor="checkbox_soiltype"
                    >
                      {gettext("Soil type")}
                    </label>
                  </div>
                  <div className="form-check custom-control-inline custom-control custom-checkbox">
                    <input
                      className="form-check-input custom-control-input"
                      type="checkbox"
                      id="checkbox_location"
                      data-filter="region"
                      value="region"
                      onChange={(e) => {
                        return this.props.changeBenchmarkFilter(e, state.benchmarkFilter);
                      }}
                    />
                    <label
                      className="form-check-label custom-control-label"
                      htmlFor="checkbox_location"
                    >
                      {gettext("Location")}
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div>
              <div
                className={loading ? "d-block" : "d-none"}
                style={{
                  position: "absolute",
                  top: "25px",
                  left: "20px",
                  width: "20px",
                  height: "20px",
                }}
                title={state.loading}
              >
                <Spinner animation="border" role="status" size="sm">
                  <span className="sr-only">{gettext("Loading")}...</span>
                </Spinner>
              </div>
              <ResponsiveContainer width="100%" height={300}>
                {this.composedChart({
                  brush: true,
                  graph: false,
                  brush_state: this.props.brush_state,
                })}
              </ResponsiveContainer>
            </div>
          </div>
        </div>
        <div className={"card-footer"}>
          {this.props.footer && (
            <a
              href={this.props.base_url + "timeline/"}
              className={"float-right btn btn-outline-smoke"}
            >
              {gettext("Details")}
            </a>
          )}
        </div>
      </div>
    );
  }
}
export default CropFieldTimeline;
